import React, { useState } from "react";
import { Grid, Stack, Typography, Button } from "@mui/material";
import AccountCircleIcon from "@mui/icons-material/AccountCircle";
import CheckCircleIcon from "@mui/icons-material/CheckCircle";
import { countries } from "country-data";
import StarIcon from "@mui/icons-material/Star";
import { useNavigate } from "react-router-dom";
import cert_01 from "../../../assets/Images/certifications/cert_01.png";
import cert_02 from "../../../assets/Images/certifications/cert_02.png";
import cert_03 from "../../../assets/Images/certifications/cert_03.png";
import cert_04 from "../../../assets/Images/certifications/cert_04.png";
import cert_05 from "../../../assets/Images/certifications/cert_05.png";
import cert_06 from "../../../assets/Images/certifications/cert_06.png";
import cert_07 from "../../../assets/Images/certifications/cert_07.png";
import cert_08 from "../../../assets/Images/certifications/cert_08.png";
import cert_09 from "../../../assets/Images/certifications/cert_09.png";
import cert_10 from "../../../assets/Images/certifications/cert_10.png";
import cert_11 from "../../../assets/Images/certifications/cert_11.png";
import cert_12 from "../../../assets/Images/certifications/cert_12.png";
import cert_13 from "../../../assets/Images/certifications/cert_13.png";
import cert_14 from "../../../assets/Images/certifications/cert_14.png";
import cert_15 from "../../../assets/Images/certifications/cert_15.png";
import cert_16 from "../../../assets/Images/certifications/cert_16.png";
import cert_17 from "../../../assets/Images/certifications/cert_17.png";
import cert_18 from "../../../assets/Images/certifications/cert_18.png";
import cert_19 from "../../../assets/Images/certifications/cert_19.png";
import cert_20 from "../../../assets/Images/certifications/cert_20.png";
import cert_21 from "../../../assets/Images/certifications/cert_21.png";
import cert_22 from "../../../assets/Images/certifications/cert_22.png";
import cert_23 from "../../../assets/Images/certifications/cert_23.png";
import cert_24 from "../../../assets/Images/certifications/cert_24.png";
import cert_25 from "../../../assets/Images/certifications/cert_25.png";
import cert_26 from "../../../assets/Images/certifications/cert_26.png";
import cert_27 from "../../../assets/Images/certifications/cert_27.png";
import cert_28 from "../../../assets/Images/certifications/cert_28.png";
import cert_29 from "../../../assets/Images/certifications/cert_29.png";
import cert_30 from "../../../assets/Images/certifications/cert_30.png";
import cert_31 from "../../../assets/Images/certifications/cert_31.png";
import cert_32 from "../../../assets/Images/certifications/cert_32.png";
import cert_33 from "../../../assets/Images/certifications/cert_33.png";
import cert_34 from "../../../assets/Images/certifications/cert_34.png";
import cert_35 from "../../../assets/Images/certifications/cert_35.png";
import cert_36 from "../../../assets/Images/certifications/cert_36.png";
import cert_37 from "../../../assets/Images/certifications/cert_37.png";
import cert_38 from "../../../assets/Images/certifications/cert_38.png";
import cert_39 from "../../../assets/Images/certifications/cert_39.png";
import cert_40 from "../../../assets/Images/certifications/cert_40.png";
import cert_41 from "../../../assets/Images/certifications/cert_41.png";
import cert_42 from "../../../assets/Images/certifications/cert_42.png";
import cert_43 from "../../../assets/Images/certifications/cert_43.png";
import cert_44 from "../../../assets/Images/certifications/cert_44.png";

const FindExpertCard = ({
  bid,
  clickHandler,
  name,
  country,
  skills,
  id,
  rating,
  certifications,
  image,
}) => {
  const navigate = useNavigate();
  const getQuoteHandler = () => {
    navigate(`/expert-profile/${id}`);
  };
  return (
    <Grid
      container
      style={{
        borderBottom: "1px solid #EEEBEF",
        marginTop: "20px",
        paddingBottom: "20px",
        cursor: "pointer",
      }}
      // alignItems="center"
      //   onClick={() => clickHandler(bid._id)}
    >
      {/* <Grid item sm={1}></Grid> */}
      <Grid item sm={2}>
        <img
          src={image}
          style={{
            height: "80px",
            width: "80px",
            color: "#EEEBEF",
            marginLeft: "20px",
            borderRadius: "50%",
            objectFit: "contain",
          }}
        />
      </Grid>
      <Grid item sm={9}>
        <Stack
          direction="row"
          justifyContent="space-between"
          alignItems="center"
        >
          <Stack
            direction="row"
            spacing={1}
            alignItems="center"
            className="mb-5"
          >
            <Typography
              style={{ fontWeight: "bold", textTransform: "capitalize" }}
            >
              {name}
            </Typography>
            <CheckCircleIcon
              style={{ height: "15px", width: "15px", color: "#FA8319" }}
            />
          </Stack>
          <Button
            variant="contained"
            className="primary-button"
            style={{ textTransform: "capitalize" }}
            onClick={getQuoteHandler}
          >
            Get Quote
          </Button>
        </Stack>

        <Typography
          className="mb-5"
          style={{ color: "rgba(122, 122, 128, 1)" }}
        >
          {country}
        </Typography>
        <Stack direction="row" spacing={3} alignItems="center">
          <Stack
            style={{
              padding: "3px",
              borderRadius: "4px",
              backgroundColor: "rgba(52, 168, 83, 0.3)",
            }}
            spacing={1}
            direction="row"
            alignItems="center"
          >
            <StarIcon
              style={{
                height: "18px",
                width: "18px",
                color: "rgba(52, 168, 83, 1)",
              }}
            />
            <Typography style={{ color: "rgba(52, 168, 83, 1)" }}>
              {rating}
            </Typography>
          </Stack>
          {certifications.map((item) =>
            item.certificationName == "Federation of Master Builders" ? (
              <img
                src={cert_01}
                style={{ width: "30px", height: "20px", objectFit: "contain" }}
              />
            ) : item.certificationName ==
              "Guild of Builders and Contractors" ? (
              <img
                src={cert_02}
                style={{ width: "30px", height: "20px", objectFit: "contain" }}
              />
            ) : item.certificationName == "Stone Federation Great Britain" ? (
              <img
                src={cert_03}
                style={{ width: "30px", height: "20px", objectFit: "contain" }}
              />
            ) : item.certificationName == "Guild of Master Craftsmen" ? (
              <img
                src={cert_04}
                style={{ width: "30px", height: "20px", objectFit: "contain" }}
              />
            ) : item.certificationName == "British Woodworking Federation" ? (
              <img
                src={cert_05}
                style={{ width: "30px", height: "20px", objectFit: "contain" }}
              />
            ) : item.certificationName ==
              "Association of Master Upholsterers & Soft Furnishers" ? (
              <img
                src={cert_06}
                style={{ width: "30px", height: "20px", objectFit: "contain" }}
              />
            ) : item.certificationName ==
              "National Carpet Cleaners Association" ? (
              <img
                src={cert_07}
                style={{ width: "30px", height: "20px", objectFit: "contain" }}
              />
            ) : item.certificationName ==
              "National Institute of Carpet & Floorlayers" ? (
              <img
                src={cert_08}
                style={{ width: "30px", height: "20px", objectFit: "contain" }}
              />
            ) : item.certificationName ==
              "The British Board of Agrément Solid Wall Insulation" ? (
              <img
                src={cert_09}
                style={{ width: "30px", height: "20px", objectFit: "contain" }}
              />
            ) : item.certificationName ==
              "The Cavity Wall Insulation Self Certification scheme" ? (
              <img
                src={cert_10}
                style={{ width: "30px", height: "20px", objectFit: "contain" }}
              />
            ) : item.certificationName == "Gas Safe Register" ? (
              <img
                src={cert_11}
                style={{ width: "30px", height: "20px", objectFit: "contain" }}
              />
            ) : item.certificationName ==
              "National Association of Chimney Engineers" ? (
              <img
                src={cert_12}
                style={{ width: "30px", height: "20px", objectFit: "contain" }}
              />
            ) : item.certificationName ==
              "National Association of Chimney Sweeps" ? (
              <img
                src={cert_13}
                style={{ width: "30px", height: "20px", objectFit: "contain" }}
              />
            ) : item.certificationName == "Blue Flame Certification" ? (
              <img
                src={cert_14}
                style={{ width: "30px", height: "20px", objectFit: "contain" }}
              />
            ) : item.certificationName == "ELECSA" ? (
              <img
                src={cert_15}
                style={{ width: "30px", height: "20px", objectFit: "contain" }}
              />
            ) : item.certificationName == "NAPIT" ? (
              <img
                src={cert_16}
                style={{ width: "30px", height: "20px", objectFit: "contain" }}
              />
            ) : item.certificationName ==
              "National Inspection Council for Electrical Installation" ? (
              <img
                src={cert_17}
                style={{ width: "30px", height: "20px", objectFit: "contain" }}
              />
            ) : item.certificationName ==
              "Association of Fencing Industries" ? (
              <img
                src={cert_18}
                style={{ width: "30px", height: "20px", objectFit: "contain" }}
              />
            ) : item.certificationName == "BAFE" ? (
              <img
                src={cert_19}
                style={{ width: "30px", height: "20px", objectFit: "contain" }}
              />
            ) : item.certificationName == "Contract Flooring Association" ? (
              <img
                src={cert_20}
                style={{ width: "30px", height: "20px", objectFit: "contain" }}
              />
            ) : item.certificationName == "CHAS" ? (
              <img
                src={cert_21}
                style={{ width: "30px", height: "20px", objectFit: "contain" }}
              />
            ) : item.certificationName == "Constructionline" ? (
              <img
                src={cert_22}
                style={{ width: "30px", height: "20px", objectFit: "contain" }}
              />
            ) : item.certificationName == "SafeContractor" ? (
              <img
                src={cert_23}
                style={{ width: "30px", height: "20px", objectFit: "contain" }}
              />
            ) : item.certificationName == "HETAS" ? (
              <img
                src={cert_24}
                style={{ width: "30px", height: "20px", objectFit: "contain" }}
              />
            ) : item.certificationName == "BALI" ? (
              <img
                src={cert_25}
                style={{ width: "30px", height: "20px", objectFit: "contain" }}
              />
            ) : item.certificationName == "Master Locksmith Association" ? (
              <img
                src={cert_26}
                style={{ width: "30px", height: "20px", objectFit: "contain" }}
              />
            ) : item.certificationName ==
              "Painting and Decorating Association" ? (
              <img
                src={cert_27}
                style={{ width: "30px", height: "20px", objectFit: "contain" }}
              />
            ) : item.certificationName == "British Pest Control Association" ? (
              <img
                src={cert_28}
                style={{ width: "30px", height: "20px", objectFit: "contain" }}
              />
            ) : item.certificationName == "NPTA" ? (
              <img
                src={cert_29}
                style={{ width: "30px", height: "20px", objectFit: "contain" }}
              />
            ) : item.certificationName == "Finishes and Interiors Sector" ? (
              <img
                src={cert_30}
                style={{ width: "30px", height: "20px", objectFit: "contain" }}
              />
            ) : item.certificationName ==
              "Association of Plumbing and Heating Contractors" ? (
              <img
                src={cert_31}
                style={{ width: "30px", height: "20px", objectFit: "contain" }}
              />
            ) : item.certificationName ==
              "Building Engineering Services Competence Assessment Limited" ? (
              <img
                src={cert_32}
                style={{ width: "30px", height: "20px", objectFit: "contain" }}
              />
            ) : item.certificationName ==
              "Chartered Institute of Plumbing and Heating Engineers" ? (
              <img
                src={cert_33}
                style={{ width: "30px", height: "20px", objectFit: "contain" }}
              />
            ) : item.certificationName ==
              "Oil Firing Technical Association Limited" ? (
              <img
                src={cert_34}
                style={{ width: "30px", height: "20px", objectFit: "contain" }}
              />
            ) : item.certificationName == "Solar Trade Association" ? (
              <img
                src={cert_35}
                style={{ width: "30px", height: "20px", objectFit: "contain" }}
              />
            ) : item.certificationName ==
              "National Federation of Roofing Contractors" ? (
              <img
                src={cert_36}
                style={{ width: "30px", height: "20px", objectFit: "contain" }}
              />
            ) : item.certificationName ==
              "National Access & Scaffolding Confederation" ? (
              <img
                src={cert_37}
                style={{ width: "30px", height: "20px", objectFit: "contain" }}
              />
            ) : item.certificationName ==
              "The National Security Inspectorate" ? (
              <img
                src={cert_38}
                style={{ width: "30px", height: "20px", objectFit: "contain" }}
              />
            ) : item.certificationName ==
              "Confederation of Aerial Industries" ? (
              <img
                src={cert_39}
                style={{ width: "30px", height: "20px", objectFit: "contain" }}
              />
            ) : item.certificationName == "Assure Certification Ltd" ? (
              <img
                src={cert_40}
                style={{ width: "30px", height: "20px", objectFit: "contain" }}
              />
            ) : item.certificationName == "CERTASS Limited" ? (
              <img
                src={cert_41}
                style={{ width: "30px", height: "20px", objectFit: "contain" }}
              />
            ) : item.certificationName ==
              "Exova BM TRADA Competent Persons Scheme" ? (
              <img
                src={cert_42}
                style={{ width: "30px", height: "20px", objectFit: "contain" }}
              />
            ) : item.certificationName == "FENSA" ? (
              <img
                src={cert_43}
                style={{ width: "30px", height: "20px", objectFit: "contain" }}
              />
            ) : item.certificationName == "Glass and Glazing Federation" ? (
              <img
                src={cert_44}
                style={{ width: "30px", height: "20px", objectFit: "contain" }}
              />
            ) : (
              <></>
            )
          )}
        </Stack>
        <Grid container className="mt-10" columnSpacing={2} rowSpacing={2}>
          {skills.map((skill) => (
            <Grid item xs="auto">
              <Typography
                className="ammanat-darker-gray skill-pill"
                style={{ fontSize: "13px" }}
              >
                {skill.label}
              </Typography>
            </Grid>
          ))}
        </Grid>
        {/* <Stack direction="row" spacing={2} className="mt-10">
          {skills.map((skill) => (
            <Typography className="ammanat-darker-gray skill-pill">
              {skill.label}
            </Typography>
          ))}
        </Stack> */}
      </Grid>
    </Grid>
  );
};

export default FindExpertCard;
